import React from "react";
import Nav from "components/HOCs/MenuNav/Nav/Nav";
import logo from "images/logocelularfire.png";
import "./DesktopNav.scss";
import { useHistory } from "react-router-dom";

const DesktopNav = ({ onAuth, setAuth }) => {
	const history = useHistory();

	return (
		<nav className="headerDesktop">
			<img src={logo} alt="" className="headerDesktop__logo" onClick={() => history.push("/")} />
			<Nav
				colorIcons="gray"
				menuMobile={false}
				onAuth={onAuth}
				setAuth={setAuth}
			/>
		</nav>
	);
};

export default DesktopNav;
